import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Profile data now comes from useUser() in useAuth.js — no separate profile endpoint.

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => api.updateUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user'] });
        },
    });
};

export const useDeleteAccount = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (password) => {
            await api.deleteUser(password);
            await api.logout();
        },
        onSettled: () => {
            queryClient.clear();
        },
    });
};
